import { clearPersistedCache } from '@/lib/idb-persister';
import { queryClient } from '@/App';
import type { AuthResetFns } from '../types';

/**
 * Clear all auth-related caches (React Query + persisted IndexedDB).
 * Single source of truth — called by both signOut and auth state changes.
 */
export async function clearAuthCaches(): Promise<void> {
  queryClient.clear();
  await clearPersistedCache().catch(() => {});
}

/**
 * Reset all auth-related stores to their default/empty state.
 */
export function resetAuthStores(fns: AuthResetFns): void {
  fns.resetProfile();
  fns.resetAdmin();
  fns.setPrivateKey(null);
  fns.resetDeviceTrust();
  fns.resetEntitlements();
}

/**
 * Full signed-out transition: reset stores + clear caches.
 */
export async function handleSignedOutTransition(fns: AuthResetFns): Promise<void> {
  resetAuthStores(fns);
  await clearAuthCaches();
}
